import { Box, IconButton, Link, useTheme } from '@material-ui/core';
import { usePartnerCustomUiConfig } from '@src/reducers/partnerCustomUiApi';
import { selectAuthenticationInfo } from '@src/selectors/user';
import { LoginSuccess } from '@src/types';
import { useSelector } from 'react-redux';

const MAX_LENGTH = 20;
const thisYear = new Date().getFullYear();
const AboutB2ChatComponent: React.FC = () => {
  const { palette } = useTheme();
  const partnersCustomUi = usePartnerCustomUiConfig();
  const user: LoginSuccess = useSelector(selectAuthenticationInfo);
  let fullEmployerName = `${user?.employer?.name}`;

  if (fullEmployerName.length > MAX_LENGTH) {
    fullEmployerName = `${fullEmployerName.slice(0, MAX_LENGTH)}...`;
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      flexDirection="column"
      style={{ margin: '16px 0px', gap: '4px' }}
    >
      <Box display="flex" alignItems="center" style={{ gap: '4px' }}>
        <Box>We</Box>
        <IconButton style={{ padding: 0, color: '#000000' }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill={palette.primary.main}
            stroke={palette.primary.main}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
          </svg>
        </IconButton>
        {fullEmployerName}
      </Box>
      <Box>
        © {thisYear}{' '}
        <Link
          href={partnersCustomUi?.webSiteUrl || 'https://www.b2chat.io/'}
          target="_blank"
          rel="noopener noreferrer"
        >
          B2Chat S.A.S
        </Link>
      </Box>
    </Box>
  );
};

export default AboutB2ChatComponent;
